import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { Box, Container, Grid, Typography } from '@material-ui/core'

import { PageTitle } from '@scoir/headers'

import MatchTableUploads from '../MatchTableUploads'
import UploadStudentData from '../UploadStudentData'
import { ReportContext } from '../ReportContextProvider'

export const Overview = ({ history }) => {
  const { uploads, onSetColumnMappingData } = useContext(ReportContext)
  return (
    <Container maxWidth="lg">
      <Box
        pt={5}
        pb={5}
      >
        <Grid
          container
          direction="column"
          spacing={3}
        >
          <Grid item>
            <PageTitle title="End of Cycle Report" />
            <Typography variant="body1">
              Upload a .CSV of your school’s prospective student data. Not sure which fields are required?
              <br />
              <a
                href="https://www.scoir.com/hubfs/College%20Solutions/CRM%20Matching%20One%20Pager.pdf"
                target="_blank"
                rel="noreferrer noopener"
              >
                See the full list of fields needed and the insights you’ll receive.
              </a>
            </Typography>
            <br />
            <Typography variant="body1">
              Your Client Success Team will provide an analysis report on your student matches and Scoir audience.
            </Typography>
          </Grid>
          <Grid item>
            <UploadStudentData
              onUploadSuccess={(response, file) => {
                onSetColumnMappingData({
                  mappingData: response,
                  file,
                })
                history.push(`${import.meta.env.BASE_URL}/engage/end-of-cycle-report/column-mapping`)
              }}
            />
          </Grid>
          <Grid item>
            <Box pt={2}>
              <Grid item>
                <Typography
                  variant="h4"
                  component="h2"
                  paragraph
                >
                  Uploaded File Log
                </Typography>
              </Grid>
              <Grid item>
                <MatchTableUploads uploads={uploads} />
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Container>
  )
}
Overview.propTypes = {
  history: PropTypes.object.isRequired,
}

export default withRouter(Overview)
